__turbopack_context__.v({
  "options": "SortControl-module-scss-module__6d0HKq__options",
  "single": "SortControl-module-scss-module__6d0HKq__single",
  "sort": "SortControl-module-scss-module__6d0HKq__sort",
});
